export default __webpack_public_path__ + "static/media/Q.a7ce9ca5.svg";